// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


import classNames from 'classnames';

import Notify from '../../utils/Notify';

import EmailInput from  './EmailInput';

export default class EmailsList extends Component {

  static defaultProps = {
    disabled: false
  };

  static propTypes = {
    value: PropTypes.string.isRequired,

    onChange: PropTypes.func.isRequired,

    disabled: PropTypes.bool,

    list: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  get emailsList(): Array<string> {
    return this.props.list;
  }

  onAddClicked = () => {
    let emailsList = this.emailsList;

    emailsList.push('');

    this.props.onChange(emailsList);
  };

  onChange = (email: string, index: number) => {
    const emailsList = this.emailsList;

    emailsList[index] = email;

    this.props.onChange(emailsList);
  };

  onDelete = (index: number) => {
    const emailsList = this.emailsList;
    const emailToDelete = emailsList[index];

    if (emailToDelete.length === 0) { // empty, delete it without asking confirmation
      emailsList.splice(index, 1);
      this.props.onChange(emailsList);
    } else {
      Notify.confirmDelete(I18n.tr('components.emails_list.are_you_sure'), (result) => {
        if (result) {
          emailsList.splice(index, 1);
          this.props.onChange(emailsList);
        }
      });
    }
  };

  //
  // Renderers
  //

  renderEmailsList(emailsList: Array<string>) {
    const listView = [];

    _.each(emailsList, (email: string, index: number) => {
      listView.push(
        <div className="input-group" style={style.listItem}>
          <EmailInput
            key={index}
            className="form-control"
            value={email}
            onChange={(email: string) => { this.onChange(email, index); }}
            readOnly={this.props.disabled}
          />
          <div className="input-group-addon">
            {!this.props.disabled &&
              <i
                className="fa fa-trash pointer"
                onClick={() => { this.onDelete(index); }}
              />
            }
          </div>
        </div>
      );
    });

    return (listView);
  }

  render() {
    return (
      <div className="emails_list">
        {this.renderEmailsList(this.emailsList)}

        {!this.props.disabled &&
          <div
            style={style.link}
            className="link"
            onClick={this.onAddClicked}
          >
            {I18n.tr('components.emails_list.add_email')}
          </div>
        }
      </div>
    );
  }
}

const style = {
  link: {
    marginTop: '10px'
  },
  listItem: {
    marginBottom: '10px'
  }
};
